const MessengerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx="36.055" cy="35.8701" rx="30.4156" ry="23.2046" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.9795 0C16.5562 0 0 15.3298 0 34.2403C0 45.0157 5.3774 54.6272 13.7812 60.9036V73.959L26.3723 67.0487C29.7327 67.9786 33.2926 68.4806 36.9795 68.4806C57.4027 68.4806 73.959 53.1507 73.959 34.2403C73.959 15.3298 57.4027 0 36.9795 0ZM40.6545 46.1102L31.2373 36.0664L12.8625 46.1102L33.0748 24.653L42.7217 34.6968L60.8669 24.653L40.6545 46.1102Z"
      fill="#007FFF"
    />
  </svg>
);
export default MessengerIcon;
